

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Deck, DeckColor  } from '@shared/models';

	@Component({})
	export default class DeckGeneralInfo extends BaseView {

		@Prop({ type: Object as PropType<Deck> })
		public model: Deck;

		@Prop({ default: () => [] })
		public palette: DeckColor[];

	}
	
